import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { LoginService } from '../login.service';
import { LoginSettings } from '../LoginSetting.model';
import { MatDialog } from '@angular/material/dialog';
import { ForgotPasswordComponent } from '../forgot-password/forgot-password.component';
import { ForgotUsernameComponent } from '../forgot-username/forgot-username.component';
import { TabsComponent } from '../../../shared-components/controls/tabs/tabs.component';

@Component({
  selector: 'app-login-assist',
  templateUrl: './login-assist.component.html',
  styleUrls: ['./login-assist.component.css']
})
export class LoginAssistComponent implements OnInit, AfterViewInit {
  @ViewChild(TabsComponent) tabs: TabsComponent;
  loginSettings: LoginSettings;
  tabNames: string[] = [];
  userType = 1;
  defaultTabIndex = 0;
  showUserType: number;
  constructor(
    private loginService: LoginService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.loginSettings = this.loginService.LoginSettings;
    this.setUserType();
    this.setTabs();
  }

  ngAfterViewInit() {
    this.tabs.selectedIndexChange(this.defaultTabIndex);
  }

  setTabs() {
    this.tabNames = [];
    this.tabNames.push('Staff');
    if (this.loginSettings.ParentPortalShowParentTab) {
      this.tabNames.push('Parent');
    }
    if (this.loginSettings.ParentPortalShowStudentTab) {
      this.tabNames.push('Student');
    }
    switch (this.userType) {
      case 1: {
        this.defaultTabIndex = this.tabNames.indexOf('Staff');
        break;
      }
      case 2: {
        this.defaultTabIndex = this.tabNames.indexOf('Parent');
        break;
      }
      case 3: {
        this.defaultTabIndex = this.tabNames.indexOf('Student');
        break;
      }
    }
  }

  setUserType = function () {
    if (localStorage && localStorage.getItem('UserType')) {
      this.userType = parseInt(localStorage.getItem('UserType'), 10);
    }
  };

  forgotPasswordClick() {
    this.loginService.LoginSettings.ShowForgotUserNameLink = false;
    const dialogRef = this.dialog.open(ForgotPasswordComponent, {disableClose: true, maxWidth: '400px', data: {userType: this.userType}});
  }

  forgotUserNameClick() {
    const dialogRef = this.dialog.open(ForgotUsernameComponent, {disableClose: true, maxWidth: '400px'});
  }

  tabChange(e: string) {
    switch (e) {
      case 'Staff': {
        this.userType = 1;
        break;
      }
      case 'Parent': {
        this.userType = 2;
        break;
      }
      case 'Student': {
        this.userType = 3;
        break;
      }
    }
  }

}
